import React from 'react';
import classNames from 'classnames';
import Icon from '@ant-design/icons';
import { Button as AntdButton } from 'antd';

import { Button, ButtonType, ButtonPropsType } from 'components/Controls/Button';
import DeleteSvg from './delete.svg';
import cn from './styles.module.scss';

export const DeleteIcon = (props: any) => <Icon component={DeleteSvg} {...props} />;

export const DeleteIconButton = React.forwardRef<HTMLButtonElement | HTMLAnchorElement, ButtonPropsType>(
  (props, ref) => (
    <AntdButton
      ref={ref}
      {...props}
      type="text"
      className={classNames(cn.deleteButton, cn.deleteButtonContainer, { [cn.disabled]: props.disabled })}
      icon={<DeleteSvg width={16} height={16} />}
    />
  ),
);
DeleteIconButton.displayName = 'DeleteIconButton';

export const DeleteOutlineIconButton = React.forwardRef<HTMLButtonElement | HTMLAnchorElement, ButtonPropsType>(
  (props, ref) => (
    <Button
      ref={ref}
      {...props}
      className={classNames(cn.deleteOutlineButton, cn.deleteButtonContainer, cn.button)}
      size="medium"
      type={ButtonType.OutlineIcon}
      icon={<DeleteIcon />}
    />
  ),
);
DeleteOutlineIconButton.displayName = 'DeleteOutlineIconButton';

export const DeleteIconRounded = ({ className, ...props }: ButtonPropsType) => (
  <div className={classNames(cn.roundedIcon, className)}>
    <DeleteIcon {...props} />
  </div>
);
